export const defaultLocation = {
  city: "Toronto",
  country: "CA",
  province: "ON",
  fullName: "Toronto, ON, Canada",
  latitude: 43.6532,
  lat: 43.6532,
  longitude: -79.347015,
  lng: -79.347015,
};

export const victoriaDefaultLocation = {
  city: "Victoria",
  country: "CA",
  province: "BC",
  latitude: 48.407326,
  longitude: -123.329773,
};
